import { motion } from "framer-motion";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import {
  Star, Fire, Lightning, Trophy, Crown, Rocket, Medal, Crosshair, ArrowUp, ShieldStar,
} from "@phosphor-icons/react";

const ACHIEVEMENT_ICONS = {
  star: Star, fire: Fire, lightning: Lightning, trophy: Trophy,
  crown: Crown, rocket: Rocket, medal: Medal, target: Crosshair,
  "arrow-up": ArrowUp, shield: ShieldStar,
};

const BADGE_INITIAL = { scale: 0.8, opacity: 0 };
const BADGE_ANIMATE = { scale: 1, opacity: 1 };

function AchievementBadge({ achievement }) {
  const IconComp = ACHIEVEMENT_ICONS[achievement.icon] || Star;
  return (
    <motion.div
      initial={BADGE_INITIAL}
      animate={BADGE_ANIMATE}
      className="flex flex-col items-center gap-2 p-3 rounded-xl bg-secondary/10 border border-secondary/20 hover:border-secondary/40 transition-all"
      data-testid={`achievement-${achievement.id}`}
    >
      <div className="w-10 h-10 rounded-full bg-secondary/20 flex items-center justify-center">
        <IconComp className="w-5 h-5 text-secondary" weight="fill" />
      </div>
      <p className="text-xs font-semibold text-center leading-tight">{achievement.name}</p>
      <p className="text-[10px] text-muted-foreground text-center">{achievement.description}</p>
    </motion.div>
  );
}

export default function PlayerAchievements({ achievements }) {
  if (!achievements || achievements.length === 0) return null;
  return (
    <Card className="bg-card border-border" data-testid="achievements-section">
      <CardHeader>
        <CardTitle className="font-heading text-lg flex items-center gap-2">
          <Medal className="w-5 h-5 text-secondary" weight="fill" />
          Achievements ({achievements.length})
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-3">
          {achievements.map(a => <AchievementBadge key={a.id} achievement={a} />)}
        </div>
      </CardContent>
    </Card>
  );
}
